<template>
  <section>
    <h3 class="primary--text"><v-icon info>person_outline</v-icon> {{$t('documento.title') }}</h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :data-graphql="dataGraphql"
          :widthModal="800"
        >
          <template slot="buttons">
            <v-tooltip bottom v-if="$store.state.permissions['documentos:create']">
              <v-btn
                @click="openDocs()"
                slot="activator"
                color="primary">
                <v-icon>add</v-icon> Agregar
              </v-btn>
              <span>Agregar documento</span>
            </v-tooltip>
            <!-- <v-tooltip bottom v-if="$store.state.permissions['documentos:create']">
              <v-btn
                color="primary"
                @click.native.stop="openModal()"
                slot="activator">
                <v-icon>create_new_folder</v-icon> {{$t('common.add') }}
              </v-btn>
              <span>{{$t('documento.add')}}</span>
            </v-tooltip> -->
          </template>

          <template slot="form" slot-scope="props">
            <v-card-title class="headline">
              <v-icon>{{ form.id ? 'folder' : 'create_new_folder' }}</v-icon> {{ form.id ? $t('documento.crud.editDocumento') : $t('documento.crud.addDocumento') }}
              <v-btn icon @click.native="$store.commit('closeModal')">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-form
              @submit.prevent="save"
              v-model="valid"
              ref="form"
              lazy-validation>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout row wrap>

                    <v-flex xs6>
                      <v-select
                        :items="entidades"
                        v-model="form.id_entidad"
                        label="Entidad"
                        item-text="text"
                        item-value="value"
                        autocomplete
                        noDataText="No hay resultados"
                        :rules="$validate(['required'])"
                        required
                        ></v-select>
                    </v-flex>

                    <v-flex xs6>
                      <v-select
                        :items="derivar_opciones"
                        v-model="form.derivar"
                        label="Derivar a:"
                        item-text="text"
                        item-value="value"
                        autocomplete
                        noDataText="No hay resultados"
                        :rules="$validate(['required'])"
                        required
                      ></v-select>
                    </v-flex>

                    <v-flex xs6>
                      <v-text-field
                        label="Nombre"
                        v-model="form.nombre"
                        maxlength="100"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs6>
                      <v-text-field
                        label="Código portal"
                        v-model="form.codigo_portal"
                        maxlength="50"
                        ></v-text-field>
                    </v-flex>

               <!--      <v-flex xs12>
                      <v-text-field
                        label="Nro. Cuenta"
                        v-model="form.cuenta"
                        maxlength="20"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                        label="Precio"
                        v-model="form.precio"
                        maxlength="10"
                        ></v-text-field>
                    </v-flex> -->

                    <v-flex xs12>
                      <v-text-field
                        label="Descripcion"
                        v-model="form.descripcion"
                        maxlength="500"
                        multi-line
                        :counter="500"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs6>
                      <v-text-field
                        label="Duración del trámite en días"
                        v-model="form.duracion"
                        maxlength="10"
                        ></v-text-field>
                    </v-flex>

                    <!-- <v-flex xs12>
                      <v-text-field
                        label="Token"
                        v-model="form.token_ppte"
                        maxlength="500"
                        multi-line
                        :counter="500"
                        ></v-text-field>
                    </v-flex> -->

                    <v-flex xs6>
                      <h5>Información de pago</h5>
                      <ul class="no-style">
                        <template v-for="(item, index) in form.monto">
                          <li>
                            <strong>Nro. de Cuenta:</strong> {{item.cuenta}} <br>
                            <strong>Monto:</strong> Bs. {{item.monto}}
                          </li>
                        </template>
                      </ul>
                    </v-flex>

                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <small class="error--text text-required">* Los campos son obligatorios</small>
                <v-spacer></v-spacer>
                <v-btn @click.native="$store.commit('closeModal');"><v-icon>cancel</v-icon> {{$t('common.cancel') }}</v-btn>
                <v-btn color="primary" type="submit"><v-icon dark>check</v-icon> {{$t('common.save') }}</v-btn>
              </v-card-actions>
            </v-form>
          </template>

          <template slot="items" slot-scope="items">
            <td class="nowrap">
              <v-tooltip bottom v-if="$store.state.permissions['documentos:update']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="editItem(items.item.id, 'documento', dataGraphql)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <v-tooltip bottom v-if="$store.state.permissions['documentos:update']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="regenerar(items.item.id)">
                  <v-icon>vpn_key</v-icon>
                </v-btn>
                <span>Regenerar Token</span>
              </v-tooltip>
              <v-tooltip bottom v-if="$store.state.permissions['documentos:delete']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="deleteItem(items.item.id, 'documento')">
                  <v-icon color="red">delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
            </td>
            <td>
              <v-tooltip bottom v-if="$store.state.permissions['documentos:update']">
                <v-switch
                  v-model="items.item.active"
                  value="ACTIVE"
                  v-if="documento !== items.item.documento"
                  @change="changeActive(items.item, items.item.id, 'documento', 'EditDocumento')"
                  slot="activator"
                  color="success"></v-switch>
                <span>Activar/desactivar registro</span>
              </v-tooltip>
              <v-tooltip bottom>
                <router-link
                  to="/account"
                  v-if="documento === items.item.documento"
                  slot="activator">
                  <v-icon>file</v-icon>
                </router-link>
                <span>Este documento soy yo, clic aquí para ir a mi cuenta.</span>
              </v-tooltip>
            </td>
            <td>{{ items.item.nombre }}</td>
            <td>{{ items.item.descripcion }}</td>
            <td>{{ items.item.codigo_portal }}</td>
            <td>{{ items.item.entidad_nombre }}</td>
            <td>
            <v-chip label color="warning" text-color="white" v-if="items.item.derivar == 'ENTIDAD'">
              {{ items.item.derivar }}
            </v-chip>

              <v-chip label color="info" text-color="white" v-if="items.item.derivar == 'CANCILLERIA'">
                {{ items.item.derivar }}
              </v-chip>

            </td>

            <td class="text-md-right">{{ items.item.precio }}</td>
            <td>
              <v-chip label color="success" text-color="white" v-if="items.item.estado == 'ACTIVO'">
                {{ items.item.estado }}
              </v-chip>
              <v-chip label color="warning" text-color="white" v-if="items.item.estado == 'INACTIVO'">
                {{ items.item.estado }}
              </v-chip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="$store.state.modal3" max-width="600">
      <add-docs :mydocs="mydocs" v-if="mydocs"></add-docs>
    </v-dialog>
    <v-dialog v-model="$store.state.modal4" max-width="600">
      <regenerar :doc="doc" v-if="doc"></regenerar>
    </v-dialog>
    <!-- login ppte -->
    <v-dialog v-model="$store.state.modal5" max-width="320">
      <login-ppte></login-ppte>
    </v-dialog>
  </section>
</template>
<script>

import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import validate from '@/common/mixins/validate';
import documento from '@/components/admin/usuario/mixins/usuario';
import LoginPpte from './LoginPpte';
import AddDocs from './AddDocs';
import Regenerar from './Regenerar';

export default {
  mixins: [ crud, validate, documento ],
  created () {
    this.user = this.$storage.getUser();
    this.usuario = this.user.usuario;
    this.entidades = [];
    this.derivar_opciones = [
      'ENTIDAD', 'CANCILLERIA'];
    this.getEntidades(1);
  },
  data () {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'documentos',
      headers: [
        { text: this.$t('common.actions'), sortable: false },
        { text: this.$t('common.active'), sortable: false },
        { text: this.$t('documento.crud.name'), value: 'nombre' },
        { text: this.$t('documento.crud.description'), value: 'descripcion' },
        { text: 'Código del portal único', value: 'codigo_portal' },
        { text: 'Entidad', value: 'id_entidad' },
        { text: 'Derivar a:', value: 'derivar' },
        { text: 'Precio', value: 'precio' },
        { text: this.$t('documento.crud.status'), value: 'estado' }
      ],
      dataGraphql: `
        id
        nombre
        descripcion
        codigo_portal
        derivar
        precio
        cuenta
        monto
        token_ppte
        duracion
        estado
        id_entidad
        entidad_nombre
      `,
      form: {
        'nombre': '',
        'descripcion': '',
        'codigo_portal': '',
        'precio': '',
        'token_ppte': '',
        'derivar': '',
        'id_entidad': ''
      },
      filters: [
        {
          field: 'nombre',
          label: this.$t('documento.crud.name'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'id_entidad',
          label: this.$t('documento.crud.entity'),
          type: 'select',
          typeG: 'Int',
          items: []
        },
        {
          field: 'estado',
          label: this.$t('documento.crud.status'),
          type: 'select',
          typeG: 'EstadoDocumento',
          items: [
            { value: '', text: 'TODOS' },
            { value: 'ACTIVO', text: 'ACTIVO' },
            { value: 'INACTIVO', text: 'INACTIVO' }
          ]
        }
      ],
      documento: null,
      doc: null,
      valid: true,
      mydocs: null
    };
  },
  methods: {
    openModal (data = {}) {
      this.$refs.form.reset();
      if (data.id) {
        this.form = data;
        this.form.id_entidad = this.getValue(this.form.id_entidad, this.entidades);
      } else {
        this.form = {
          'nombre': '',
          'descripcion': '',
          'token_ppte': '',
          'derivar': '',
          'id_entidad': ''
        };
      }
      this.$store.commit('openModal');
    },
    save () {
      if (this.$refs.form.validate()) {
        let data = Object.assign({}, this.form);
        if (data.id_entidad.value) {
          data.id_entidad = data.id_entidad.value;
        }
        if (data.id) {
          delete data.id;
          delete data.entidad_nombre;
          this.$service.graphql({
            query: `
              mutation edit($id: Int!, $documento: EditDocumento!) {
                documentoEdit(id: $id, documento: $documento) {
                  id
                }
              }
            `,
            variables: {
              id: this.form.id,
              documento: data
            }
          }).then(response => {
            if (response) {
              this.$store.commit('closeModal');
              this.updateList();
              this.$message.success('Se actualizó el registro correctamente');
            }
          });
        } else {
          this.$service.graphql({
            query: `
              mutation add($documento: NewDocumento!) {
                documentoAdd(documento: $documento) {
                  id
                }
              }
            `,
            variables: {
              documento: data
            }
          }).then(response => {
            if (response) {
              this.$store.commit('closeModal');
              this.updateList();
              this.$message.success();
            }
          });
        }
      }
    },
    openDocs () {
      // verificar si existe usuario y password de ppte.
      this.$service.get(`eapostilla/verificar_datos_usuario_ppte`)
      .then(response => {
        if (response && response.redirect) {
          if (response.redirect === 'auth') {
            this.$store.commit('openModal', 5);
          } else {
            this.getDocumentos();
          }
        }
      });
    },
    regenerar (id) {
      // verificar si existe usuario y password de ppte.
      this.$service.get(`eapostilla/verificar_datos_usuario_ppte`)
      .then(response => {
        if (response && response.redirect) {
          if (response.redirect === 'auth') {
            this.$store.commit('openModal', 5);
          } else {
            this.getDoc(id);
          }
        }
      });
    },
    getDoc (id) {
      this.doc = null;
      this.$service.get(`eapostilla/obtener_doc/${id}`)
      .then(response => {
        if (response) {
          this.doc = response;
          this.$store.commit('openModal', 4);
        }
      });
    },
    getDocumentos () {
      this.mydocs = null;
      this.$service.get(`eapostilla/obtener_docs`)
      .then(response => {
        if (response) {
          this.mydocs = response;
          if (this.mydocs.length === 0) {
            this.$alert('La entidad ya no cuenta con trámites en el Portal único de trámites para agregar');
          } else {
            this.$store.commit('openModal', 3);
          }
        }
      });
    }
  },
  components: {
    CrudTable,
    AddDocs,
    LoginPpte,
    Regenerar
  },
  watch: {
    '$store.state.action': function (val) {
      if (val === 'getDocumentos') {
        this.getDocumentos();
      }
      if (val === 'getDoc') {
        this.getDoc(this.$store.state.data);
      }
      this.$store.commit('setAction', null);
    }
  }
};
</script>



// WEBPACK FOOTER //
// Documento.vue?7213ae7b